import React from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import './Products.sass'
import TabNav from '../../ui/TabNav/TabNav'
import ProductsSyncMenu from '../../api/ProductsSyncMenu/ProductsSyncMenu'
import Brands from './components/Brands/Brands'
import CatalogTaxonomy from './components/CatalogTaxonomy/CatalogTaxonomy'
import ProductsList from './components/ProductsList/ProductsList'
import OutletList from './components/OutletList/OutletList'

const CATEGORY_TREE_PATH = '/products/category-tree'

function Products() {
  const { pathname } = useLocation()
  const isCategoryTree = pathname === CATEGORY_TREE_PATH || pathname.startsWith(`${CATEGORY_TREE_PATH}/`)

  const tabNavLinks = [
    { title: 'Дерево категорій', path: CATEGORY_TREE_PATH },
    { title: 'Бренди', path: '/products/brands' },
    { title: 'Товари', path: '/products/list' },
    { title: 'Outlet каталог', path: '/products/outlet/list' },
  ]

  return (
    <>
      <TabNav links={tabNavLinks} buttons={isCategoryTree ? null : <ProductsSyncMenu />} />
      <div className="Products">
        <Switch>
          <Route path={['/products/brands/:brandId', `/products/brands`]} render={() => <Brands />} />
          <Route
            path={[`${CATEGORY_TREE_PATH}/:nodeId`, CATEGORY_TREE_PATH]}
            render={() => <CatalogTaxonomy />}
          />
          <Route
            path={['/products/list/:brandId/:productId', '/products/list/:brandId', `/products/list`]}
            render={() => <ProductsList />}
          />
          <Route
            exact
            path={[
              '/products/outlet/list/:brandId/:productId',
              '/products/outlet/list/:brandId',
              '/products/outlet/list',
            ]}
            render={(routeProps) => <OutletList {...routeProps} />}
          />
        </Switch>
      </div>
    </>
  )
}

export default Products
